import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from '../types/api';
import WebApp from '@twa-dev/sdk';


const API_URL = 'https://red.sigma-dev.co.ua/mini-state';

async function fetchData(): Promise<ApiResponse> {
  const response = await fetch(API_URL, {
    headers: { 
      'init-data': WebApp.initData,
    }
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
}

export function useApiData() {
  return useQuery<ApiResponse, Error>({
    queryKey: ['miniState'],
    queryFn: fetchData,
    refetchInterval: 30000, // Refetch every 30 seconds
    staleTime: 30000, // Consider data stale after 10 seconds
  });
} 